
import { defineComponent, PropType } from 'vue'
import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
        isPriceOrange: {
            type: Boolean,
            default: false,
        },
        price: {
            type: Number as PropType<string | number | null>,
            default: null
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = () => {
            if (props.disabled || props.selected) return
            emit('click')
        }

        return {
            formatPriceToTenge,
            onClick
        }
    }
})
